import { mainColor, BORDER_RADIUS, UNIT } from '../../constants/theme';

export const styles = () => ({
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
    minWidth: UNIT * 12
  },
  smallHeading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
    minWidth: UNIT * 9
  },

  hover: {},
  hrStyle: {
    border: '0',
    height: '1px',
    backgroundImage:
      'linear-gradient(to right, rgba(200, 200, 200, 0.5), rgba(200, 200, 200, 0.75), rgba(200, 200, 200, 0.5))'
  },
  driverSection: {
    paddingLeft: UNIT * 0.9375,
    height: UNIT * 3.5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    minWidth: UNIT * 14,
    borderRadius: UNIT,
    backgroundColor: mainColor.colorWhite
  },
  rightBtn: {
    marginRight: UNIT * 0.375
  },
  textStyle: {
    fontWeight: 'bolder',
    fontSize: UNIT * 0.8
  },
  paperStyle: {
    borderRadius: BORDER_RADIUS,
    position: 'relative'
  },
  notificationStyle: {
    color: 'red',
    position: 'absolute',
    zIndex: '2',
    top: '5px',
    width: '18px',
    height: '18px'
  },

  progress: {
    color: mainColor.secondaryColor,
    margin: UNIT * 5
  },
  orderDetail: {
    fontSize: UNIT * 1.25,
    fontWeight: 'bolder'
  },
  svg: {
    padding: UNIT * 0.625
  },
  arroundIcon: {
    backgroundColor: 'white',
    margin: 5,
    marginLeft: 0,
    padding: UNIT * 0.5,
    borderRadius: UNIT * 0.625
  },

  boldText: {
    fontSize: UNIT * 0.75,
    borderRadius: UNIT,
    display: 'flex',
    justifyContent: 'center',
    padding: '5px 6px 5px 6px',
    minWidth: UNIT * 1.5
  }
});
